<div class="details-item">
  @if (!showPlaceholder) {
    @if (label) {
      <div class="details-item-label" [class.primary]="isPrimary">
        @if (iconName) {
          <rkt-icon [name]="iconName"></rkt-icon>
        }
        {{ label }}
        <ng-container *ngTemplateOutlet="labelBtnTemplate"></ng-container>
      </div>
    }
    <div
      class="details-item-value"
      [class.muted]="isValueMuted"
      [class.no-break]="noBreak"
      [class.word-wrap-all]="wordWrap"
      [class.loading]="showPlaceholder"
      [title]="contentValue ? '' : (title || value | notAvailable)"
      [class.empty-value]="!showPlaceholder && !value && !contentValue"
    >
      {{ showPlaceholder || contentValue ? '' : (value | notAvailable) }}
      <ng-content></ng-content>
    </div>
  } @else {
    <app-details-item-placeholder
      [isDarkBg]="isDarkBg"
      [isPrimary]="isPrimary"
      [label]="label"
      [showLabel]="showPlaceholderLabel"
      [multiline]="multiline"
    ></app-details-item-placeholder>
  }
</div>
